import { validateEmail } from '../../util/email';

export const getUserValidationErrors = user => {
  const errors = {};
  if (!user.email || !validateEmail(user.email)) {
    errors.email = 'a valid email address is required';
  }
  if (user.phone) {
    if (typeof user.phone !== 'string') {
      errors.phone = 'invalid phone number';
    } else if (user.phone.length > 15) {
      errors.phone = 'phone number is too long';
    } else {
      let count = 0;
      for (let i = 0; i < user.phone.length; i++) {
        const char = user.phone.substring(i, i + 1);
        if (/^\d+$/.test(char)) count++;
      }
      if (count < 7) {
        errors.phone = 'phone number is missing digits';
      }
    }
  }
  return errors;
};

export const isValidUser = user => {
  if (!user) return false;
  const errors = getUserValidationErrors(user);
  return Object.values(errors).length < 1;
};

export const permsHaveChanged = (perms1, perms2) => {
  if (!perms1 !== !perms2) return true;
  if (perms1) {
    if (perms1.canPostOnBeefBook !== perms2.canPostOnBeefBook) return true;
    if (perms1.canPostOnGBI !== perms2.canPostOnGBI) return true;
    if (perms1.canViewFarmerPages !== perms2.canViewFarmerPages) return true;
    if (perms1.ultrasound !== perms2.ultrasound) return true;
  }
  return false;
};

export const userHasChanged = (user1, user2) => {
  if (!user1 && !!user2) return true;
  if (!user2 && !!user1) return true;
  if (!user1 && !user2) return false;
  if (user1.id !== user2.id) return true;
  if (user1.name !== user2.name) return true;
  if (user1.email !== user2.email) return true;
  if (user1.phone !== user2.phone) return true;
  if (Array.isArray(user1.orgIds) !== Array.isArray(user2.orgIds)) {
    return true;
  }
  if (Array.isArray(user1.orgIds)) {
    for (let i = 0; i < user1.orgIds.length; i++) {
      try {
        if (user1.orgIds.includes(user2.orgIds[i]) === false) return true;
      } catch (error) {
        return true;
      }
    }
  }
  if (permsHaveChanged(user1.permissions, user2.permissions)) return true;

  if (user1.emailAuthenticated !== user2.emailAuthenticated) return true;
  return false;
};
